import React, { useState, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

// Services
import { vehicleGroupService } from "../../../Services/vehicle.group.service";

// Icons
import { FaMapMarkedAlt } from "react-icons/fa";
import { HiOutlineRectangleGroup } from "react-icons/hi2";
import { FaCar } from "react-icons/fa";

// Libs
import CryptoJS from "crypto-js";
import { vehicleService } from "../../../Services/vehicle.service";

// Components
import { Filters } from "../../../components/Filters";
import { useSelected } from "../../../contexts/SelectedContext";
import { useTranslation } from "react-i18next";

export default function ViewMapFilters() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  dispatch({ type: "title", value: t("VIEW_MAP_FILTERS.TITLE") });

  const [viewVisits, setViewVisits] = useState(false);
  const { vehicleSelected } = useSelector(
    (rootReducer) => rootReducer.vehicleSelectedReducer
  );

  // Filters
  const [filtersLoading, setFiltersLoading] = useState(false);
  const [isLoadingVehicles, setIsLoadingVehicles] = useState(false);
  
  // SelectedContext
  const { selectedValues } = useSelected();
  const selectedGroup = selectedValues.veiculos?.[0] || 0;
  const selectedVehicle = selectedValues.veiculosGroups?.[0] || 0;
  
  const [vehicleGroups, setVehicleGroups] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  
  const fetchVehicleGroups = async () => {
    try {
      setFiltersLoading(true);
      const groups = await vehicleGroupService.fetchGroups();
      
      // Garante que sempre seja um array, mesmo quando a API retorna erro
      if (Array.isArray(groups)) {
        setVehicleGroups(groups);
        if (groups.length === 1) {
          await fetchVehiclesByGroup(groups[0].vehicleGroupId);
        } else {
          await fetchVehiclesByGroup(0);
        }
      } else {
        // Se retornou null, undefined ou objeto de erro, define como array vazio
        setVehicleGroups([]);
        if (groups?.error) {
          console.log("Erro ao buscar grupos:", groups.message || groups.friendlyMessage);
        }
        await fetchVehiclesByGroup(0);
      }
    } catch (error) {
      console.log(error);
      setVehicleGroups([]);
    } finally {
      setFiltersLoading(false);
    }
  };

  const fetchVehiclesByGroup = async (groupId) => {
    setIsLoadingVehicles(true);
    try {
      const vehicles = await vehicleService.fetchVehicles(groupId);
      // Garante que sempre seja um array, mesmo quando a API retorna erro
      if (Array.isArray(vehicles)) {
        setVehicles(vehicles);
      } else {
        // Se retornou null, undefined ou objeto de erro, define como array vazio
        setVehicles([]);
        if (vehicles?.error) {
          console.log("Erro ao buscar veículos:", vehicles.message || vehicles.friendlyMessage);
        }
      }
    } catch (error) {
      console.log(error);
      setVehicles([]);
    } finally {
      setIsLoadingVehicles(false);
    }
  };

  // Carrega veículos quando o grupo selecionado muda
  useEffect(() => {
    if (selectedGroup !== null && selectedGroup !== undefined) {
      fetchVehiclesByGroup(selectedGroup);
    }
  }, [selectedGroup]);

  const showMap = () => {
    const secretKey = process.env.REACT_APP_CRYPTO_SECRET;

    let url = "/#/viewmap";

    const groupCrypto = encodeURIComponent(
      CryptoJS.AES.encrypt(selectedGroup.toString(), secretKey).toString()
    );
    url += "/" + groupCrypto;

    const vehicleCrypto = encodeURIComponent(
      CryptoJS.AES.encrypt(selectedVehicle.toString(), secretKey).toString()
    );
    url += "/" + vehicleCrypto;

    const showVisits = encodeURIComponent(
      CryptoJS.AES.encrypt(viewVisits.toString(), secretKey).toString()
    );
    url += "/" + showVisits;

    window.open(
      url,
      "_blank",
      "popup, toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes"
    );
  };

  useEffect(() => {
    fetchVehicleGroups();
  }, []);

  return (
    <div className="container-xxl flex-grow-1 container-p-y">
      <div className="nav-align-top">
        {/* -- Filtros -- */}
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="mb-1 col-md-4">
            <Filters
              id={"veiculos"}
              isMulti={false}
              title={t("VIEW_MAP_FILTERS.GROUPS")}
              hasSubTitle={true}
              subTitle={t("VIEW_MAP_FILTERS.ALL_GROUPS")}
              options={vehicleGroups || []}
              icon={HiOutlineRectangleGroup}
              hasIcon={true}
              pageTitle={t("VIEW_MAP_FILTERS.TITLE")}
            />
          </div>
          <div className="mb-1 col-md-4">
            <Filters
              id={"veiculosGroups"}
              isMulti={false}
              title={t("VIEW_MAP_FILTERS.VEHICLES")}
              hasSubTitle={true}
              subTitle={t("VIEW_MAP_FILTERS.ALL_VEHICLES")}
              options={vehicles || []}
              icon={FaCar}
              hasIcon={true}
              pageTitle={t("VIEW_MAP_FILTERS.TITLE")}
              isLoading={isLoadingVehicles}
            />
          </div>
          <div className="mb-1 col-md-2 offset-md-1">
            <div className="form-check form-switch m-2 ">
              <input
                className="form-check-input"
                type="checkbox"
                id="flexSwitchCheckDefault"
                onChange={() => setViewVisits(!viewVisits)}
                checked={viewVisits}
              />
              <label className="form-check-label" htmlFor="flexSwitchCheckDefault">
                {t("VIEW_MAP_FILTERS.VIEW_VISITS")}
              </label>
            </div>
          </div>

          <div className="mb-1 col-md-3">
            <button
              type="button"
              disabled={filtersLoading}
              className="btn btn-primary"
              onClick={() => showMap()}
            >
              <FaMapMarkedAlt style={{ paddingRight: "4px" }} size={20} />
              {t("VIEW_MAP_FILTERS.OPEN_VISUALIZATION")}
            </button>
          </div>
        </div>
        <div className="row">
          <div id="defaultFormControlHelp" className="form-text">
            {t("VIEW_MAP_FILTERS.HELP_TEXT")}
          </div>
        </div>
      </div>
    </div>
  );
}